'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import AuthProviderWrapper from './AuthProviderWrapper';
import { CartProvider } from '@/contexts/CartContext';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { ToastProvider } from '@/contexts/ToastContext';
import { ModalProvider } from '@/contexts/ModalContext';
import Footer from '@/components/Footer';
import Navbar from '@/components/Navbar';
import WarningBanner from '@/components/WarningBanner';
import RejectedGuard from './RejectedGuard';

export default function ClientLayout({
	children,
}: {
	children: React.ReactNode;
}) {
	const pathname = usePathname();
	const isAdmin = pathname?.startsWith('/admin');
	const isLogistics = pathname?.startsWith('/logistics');

	return (
		<AuthProviderWrapper>
			<ToastProvider>
				<ModalProvider>
					<NotificationProvider>
						<CartProvider>
							<WarningBanner />
							<RejectedGuard>
								{!isAdmin && !isLogistics && <Navbar />}
		
									{/*
										If admin or logistics, full width (handled by their own layout), else centered max-width container
									*/}
									<main className={isAdmin || isLogistics ? '' : 'max-w-7xl mx-auto px-4 md:px-0 py-8'}>
										{children}
									</main>
		
									{!isAdmin && !isLogistics && <Footer />}
							</RejectedGuard>
						</CartProvider>
					</NotificationProvider>
				</ModalProvider>
			</ToastProvider>
		</AuthProviderWrapper>
	);
}
